/* Nordestic · Inhaltsseiten: Einblenden, Skizzen zeichnen, Kapitel-Navigation, Videos, Zähler */
(() => {
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  const initReveal = () => {
    const items = $$('.np [data-np-reveal], .np .np-draw');
    if (!('IntersectionObserver' in window) || reduce) { items.forEach(e => e.classList.add('is-in')); return; }
    const io = new IntersectionObserver(entries => entries.forEach(en => {
      if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
    }), {rootMargin: '0px 0px 20% 0px', threshold: 0});
    items.forEach(e => io.observe(e));
  };

  const initSketches = () => {
    $$('.np-draw').forEach(svg => {
      $$('.pen', svg).forEach((p, i) => {
        try { const len = Math.ceil(p.getTotalLength()) + 2; p.style.setProperty('--len', len); p.style.transitionDelay = `${Math.min(i * .12, 1.6)}s`; } catch {}
      });
    });
  };

  const initToc = () => {
    $$('[data-np-toc]').forEach(nav => {
      const links = $$('a[href^="#"]', nav);
      const targets = links.map(a => document.getElementById(a.getAttribute('href').slice(1))).filter(Boolean);
      const header = () => (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 72);
      nav.style.setProperty('--np-sticky-top', header() + 'px');
      links.forEach(a => a.addEventListener('click', e => {
        const t = document.getElementById(a.getAttribute('href').slice(1));
        if (!t) return;
        e.preventDefault();
        window.scrollTo({top: t.getBoundingClientRect().top + scrollY - header() - nav.offsetHeight - 8, behavior: reduce ? 'auto' : 'smooth'});
      }));
      if (!targets.length || !('IntersectionObserver' in window)) return;
      const io = new IntersectionObserver(entries => entries.forEach(en => {
        if (!en.isIntersecting) return;
        links.forEach(a => {
          const on = a.getAttribute('href') === '#' + en.target.id;
          a.classList.toggle('is-active', on);
          // nur die Kapitelleiste waagerecht verschieben, nie die Seite (scrollIntoView würde die Seite mitziehen)
          if (on) { const ol = a.closest('ol'); if (ol) ol.scrollTo({left: a.offsetLeft - (ol.clientWidth - a.offsetWidth) / 2, behavior: reduce ? 'auto' : 'smooth'}); }
        });
      }), {rootMargin: '-45% 0px -50% 0px'});
      targets.forEach(t => io.observe(t));
    });
  };

  // Video: Poster mit Play-Knopf, lädt das Video erst beim Klick
  const initVideos = () => {
    $$('[data-np-video]').forEach(box => {
      const btn = box.querySelector('.np-play');
      if (!btn) return;
      btn.addEventListener('click', () => {
        const tpl = box.querySelector('template');
        if (!tpl) return;
        box.replaceChildren(tpl.content.cloneNode(true));
        const v = box.querySelector('video'); if (v) { v.play?.().catch(() => {}); }
      });
    });
    // Hintergrundvideos (stumm, Schleife) nur abspielen, wenn sichtbar
    const bg = $$('video[data-np-autoplay]');
    if (!bg.length) return;
    if (reduce) { bg.forEach(v => v.removeAttribute('autoplay')); return; }
    // Hintergrundvideo erst laden, wenn die Seite steht – nicht im Datensparmodus und nicht bei langsamem Netz (dann bleibt das Standbild)
    const c = navigator.connection, slow = c && (c.saveData || /(^|-)2g|3g/.test(c.effectiveType || ''));
    // R76: Video erst laden, wenn es in die Nähe des Bildschirms kommt (spart mehrere MB auf langen Seiten)
    const armOne = v => { if (v.dataset.src && !v.src) { v.src = v.dataset.src; v.preload = 'auto'; const r = v.getBoundingClientRect(); if (r.bottom > 0 && r.top < innerHeight) v.play?.().catch(() => {}); } };
    const near = 'IntersectionObserver' in window ? new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { armOne(en.target); near.unobserve(en.target); } }), {rootMargin: '600px 0px'}) : null;
    const arm = () => bg.forEach(v => near ? near.observe(v) : armOne(v));
    if (!slow) { if (document.readyState === 'complete') setTimeout(arm, 300); else addEventListener('load', () => setTimeout(arm, 300), {once: true}); }
    const io = new IntersectionObserver(entries => entries.forEach(en => { const v = en.target; if (en.isIntersecting) v.play?.().catch(() => {}); else v.pause?.(); }), {threshold: .15});
    bg.forEach(v => io.observe(v));
  };

  // Zähler hochzählen, wenn sichtbar
  const fmt = (n, dec) => n.toLocaleString('fr-FR', {minimumFractionDigits: dec, maximumFractionDigits: dec});
  const countUp = el => {
    const to = parseFloat(el.dataset.npCount); if (!isFinite(to)) return;
    const dec = parseInt(el.dataset.npDec || '0', 10);
    if (reduce) { el.textContent = fmt(to, dec); return; }
    const t0 = performance.now(), dur = 1600;
    const step = t => { const k = Math.min(1, (t - t0) / dur); const e = 1 - Math.pow(1 - k, 3); el.textContent = fmt(to * e, dec); if (k < 1) requestAnimationFrame(step); };
    requestAnimationFrame(step);
  };
  const initCounters = () => {
    const els = $$('[data-np-count]');
    if (!('IntersectionObserver' in window)) { els.forEach(countUp); return; }
    const io = new IntersectionObserver(entries => entries.forEach(en => { if (en.isIntersecting) { countUp(en.target); io.unobserve(en.target); } }), {threshold: .4});
    els.forEach(e => io.observe(e));
  };


  // Scroll-Geschichte: Text links scrollt, Bild rechts wechselt
  const initScrolly = () => {
    $$('[data-np-scrolly]').forEach(root => {
      const steps = $$('[data-np-sc-step]', root), frames = $$('[data-np-sc-frame]', root);
      if (!steps.length || !('IntersectionObserver' in window)) { steps.forEach(s => s.classList.add('is-on')); return; }
      const set = i => { steps.forEach((s, k) => s.classList.toggle('is-on', k === i)); frames.forEach((f, k) => f.classList.toggle('is-on', k === i)); };
      set(0);
      const io = new IntersectionObserver(entries => entries.forEach(en => { if (en.isIntersecting) set(steps.indexOf(en.target)); }), {rootMargin: '-48% 0px -48% 0px'});
      steps.forEach(s => io.observe(s));
    });
  };

  // Skizze wird Foto: Zeichnung entsteht, dann schiebt sich beim Scrollen das Foto darüber
  const initRevealStage = () => {
    $$('[data-np-reveal-stage]').forEach(root => {
      const box = root.querySelector('.np-rvl-box'); if (!box) return;
      const items = $$('.np-rvl-steps li', root);
      const mark = p => { const n = items.length; items.forEach((li, k) => li.classList.toggle('is-on', n < 2 ? true : p >= k / (n - 1) - .02 || (k === 0))); };
      if (reduce) { box.style.setProperty('--p', '.5'); mark(1); return; }
      let ticking = false;
      const update = () => {
        ticking = false;
        const r = box.getBoundingClientRect(), vh = innerHeight;
        // 0 wenn die Box unten im Bild erscheint (+ etwas Zeit fürs Zeichnen), 1 wenn sie das obere Drittel erreicht
        const start = vh * .55, end = vh * .1;
        const p = Math.max(0, Math.min(1, (start - r.top) / (start - end)));
        box.style.setProperty('--p', p.toFixed(3)); mark(p);
      };
      const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
      addEventListener('scroll', onScroll, {passive: true}); addEventListener('resize', onScroll); update();
    });
  };

  // Karte: Route zeichnen
  const initMaps = () => {
    $$('.np-map-eu').forEach(svg => {
      $$('.route-draw', svg).forEach((p, i) => { try { p.style.setProperty('--len', Math.ceil(p.getTotalLength()) + 2); p.style.transitionDelay = `${.3 + i * .35}s`; } catch {} });
      if (reduce || !('IntersectionObserver' in window)) { svg.classList.add('is-in'); return; }
      const io = new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { svg.classList.add('is-in'); io.disconnect(); } }), {threshold: .3});
      io.observe(svg);
    });
  };


  // Balken (Weg zu dir) + Film wächst beim Scrollen
  const initFx = () => {
    $$('[data-np-bars]').forEach(el => {
      if (reduce || !('IntersectionObserver' in window)) { el.classList.add('is-in'); return; }
      const io = new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { el.classList.add('is-in'); io.disconnect(); } }), {threshold: .4}); io.observe(el);
    });
    const films = $$('.np-film [data-np-reveal]>.np-media');
    if (!films.length || reduce) return;
    let tick = false;
    const upd = () => { tick = false; films.forEach(m => { const r = m.parentElement.getBoundingClientRect(); const k = Math.max(0, Math.min(1, (innerHeight - r.top) / (innerHeight * .8))); m.style.setProperty('--fs', (0.9 + 0.1 * k).toFixed(3)); }); };
    addEventListener('scroll', () => { if (!tick) { tick = true; requestAnimationFrame(upd); } }, {passive: true}); upd();
  };


  // Röntgenblick: Umschalter, springt einmal von selbst um, wenn sichtbar
  const initXray = () => {
    $$('[data-np-xray]').forEach(root => {
      const btns = $$('[data-np-xr]', root); let touched = false;
      const set = v => { root.dataset.state = v; btns.forEach(b => { const on = b.dataset.npXr === v; b.classList.toggle('is-on', on); b.setAttribute('aria-selected', on); }); };
      btns.forEach(b => b.addEventListener('click', () => { touched = true; set(b.dataset.npXr); }));
      root.addEventListener('mouseenter', () => { if (!touched) { touched = true; set('b'); } });
      if (!('IntersectionObserver' in window)) return;
      const io = new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { io.disconnect(); setTimeout(() => { if (!touched) set('b'); }, 2600); } }), {threshold: .5});
      io.observe(root);
    });
  };


  // Hinter die Kulissen: ziehen, tippen, Pfeiltasten; kurzer Teaser beim ersten Sichtkontakt
  const initBehind = () => {
    $$('[data-np-behind]').forEach(box => {
      const h = box.querySelector('.np-bh-handle'); let x = 78, drag = false, touched = false;
      const set = v => { x = Math.max(2, Math.min(98, v)); box.style.setProperty('--x', x + '%'); h && h.setAttribute('aria-valuenow', Math.round(x)); };
      const fromEv = e => { const r = box.getBoundingClientRect(); set((e.clientX - r.left) / r.width * 100); };
      box.addEventListener('pointerdown', e => { drag = true; touched = true; box.classList.remove('is-tease'); box.setPointerCapture(e.pointerId); fromEv(e); });
      box.addEventListener('pointermove', e => { if (drag) fromEv(e); });
      ['pointerup','pointercancel'].forEach(t => box.addEventListener(t, () => { drag = false; }));
      h && h.addEventListener('keydown', e => { if (e.key === 'ArrowLeft') { touched = true; set(x - 5); e.preventDefault(); } if (e.key === 'ArrowRight') { touched = true; set(x + 5); e.preventDefault(); } });
      if (reduce || !('IntersectionObserver' in window)) return;
      const io = new IntersectionObserver(es => es.forEach(en => { if (!en.isIntersecting) return; io.disconnect();
        setTimeout(() => { if (touched) return; box.classList.add('is-tease'); set(30);
          setTimeout(() => { if (!touched) set(62); setTimeout(() => box.classList.remove('is-tease'), 1200); }, 1500); }, 700); }), {threshold: .55});
      io.observe(box);
    });
    $$('.np-fq2-q').forEach(q => q.addEventListener('click', () => { const li = q.closest('.np-fq2-item'); const o = li.classList.toggle('is-open'); q.setAttribute('aria-expanded', o); }));
  };


  // Waage: jede Karte, die ins Bild scrollt, legt ein Gewicht auf „Nordestic”
  const initScale = () => {
    $$('[data-np-scale]').forEach(root => {
      if (root.dataset.npScaleInit) return; root.dataset.npScaleInit = '1';
      const rows = $$('[data-np-row]', root), total = rows.length || 1, score = root.querySelector('[data-np-score]');
      const list = root.querySelector('.np-sl-rows');
      const ws = $$('[data-np-w]', root), bar = root.querySelector('[data-np-bar]'), svg = root.querySelector('.np-sl-svg'), art = root.querySelector('.np-sl-art');
      const T0 = -13, T1 = 15; let n = -1, raf = 0;
      const set = (p, cnt) => {
        const t = T0 + p * (T1 - T0), dy = Math.sin(t * Math.PI / 180) * 164, k = svg ? svg.getBoundingClientRect().width / 420 : 1;
        root.style.setProperty('--t', t.toFixed(2) + 'deg'); root.style.setProperty('--dy', (dy * k).toFixed(1) + 'px');
        if (cnt !== n) {
          const up = cnt > n && n >= 0; n = cnt;
          ws.forEach((w, i) => w.classList.toggle('is-on', i < n));
          rows.forEach((r, i) => { r.classList.toggle('is-current', i === n - 1); if (i < n) r.classList.add('is-on'); });
          if (bar) bar.style.width = (n / total * 100) + '%';
          if (score) score.textContent = n; root.classList.toggle('is-done', n >= total);
          if (up) [[art, 'is-nudge'], [score, 'is-pop']].forEach(([el, c]) => { if (!el) return; el.classList.remove(c); void el.offsetWidth; el.classList.add(c); });
        }
      };
      const tick = () => { raf = 0;
        const line = innerHeight * 0.62, lr = list.getBoundingClientRect();
        let cnt = 0; rows.forEach(r => { if (r.getBoundingClientRect().top + 40 < line) cnt++; });
        const first = rows[0].getBoundingClientRect().top + 40, last = rows[rows.length - 1].getBoundingClientRect().top + 40;
        const p = Math.max(0, Math.min(1, (line - first) / Math.max(1, last - first)));
        set(cnt ? p : 0, cnt); };
      const req = () => { if (!raf) raf = requestAnimationFrame(tick); };
      addEventListener('scroll', req, {passive: true}); addEventListener('resize', req); tick();
    });
  };

  // Bilder: sanft einblenden statt aufploppen, danach restliche Bilder im Hintergrund vorladen
  const initImages = () => {
    const imgs = $$('.np img');
    imgs.forEach(img => {
      if (img.dataset.npImg) return; img.dataset.npImg = '1'; img.decoding = 'async';
      if (!img.complete && !reduce) {
        img.classList.add('np-lz');
        const done = () => { img.classList.remove('np-lz'); img.classList.add('np-fade'); };
        img.addEventListener('load', done, {once: true}); img.addEventListener('error', () => img.classList.remove('np-lz'), {once: true});
      }
    });
    if (navigator.connection && navigator.connection.saveData) return;
    const warm = () => {
      const lazy = imgs.filter(i => i.loading === 'lazy' && !i.closest('[data-nowarm]')); let k = 0;
      const next = () => { for (let j = 0; j < 4 && k < lazy.length; j++, k++) lazy[k].loading = 'eager'; if (k < lazy.length) setTimeout(next, 200); };
      next();
    };
    const idle = window.requestIdleCallback || (f => setTimeout(f, 300));
    if (document.readyState === 'complete') idle(warm); else addEventListener('load', () => idle(warm), {once: true});
  };

  // Weg zu dir: Wettlauf Lieferzeit (Tageszähler, LKW kommt an, Schiff noch auf See)
  const initRace = () => {
    $$('[data-np-race]').forEach(root => {
      if (root.dataset.npRaceInit) return; root.dataset.npRaceInit = '1';
      const us = +root.dataset.us || 6, them = +root.dataset.them || 42, end = +root.dataset.end || 7;
      const day = root.querySelector('[data-np-day]'), lu = root.querySelector('.np-rc-lane.is-us'), lt = root.querySelector('.np-rc-lane.is-them');
      const tu = lu.querySelector('.np-rc-track'), tt = lt.querySelector('.np-rc-track');
      const set = d => { tu.style.setProperty('--p', Math.min(1, d / us).toFixed(3)); tt.style.setProperty('--p', Math.min(1, d / them).toFixed(3));
        if (day) day.textContent = Math.floor(d); lu.classList.toggle('is-arrived', d >= us); root.classList.toggle('is-done', d >= end); };
      if (reduce || !('IntersectionObserver' in window)) { set(end); return; }
      set(0);
      const run = () => { const t0 = performance.now(), dur = 4200; const step = t => { const k = Math.min(1, (t - t0) / dur); set(end * (1 - Math.pow(1 - k, 1.6))); if (k < 1) requestAnimationFrame(step); }; requestAnimationFrame(step); };
      const io = new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { io.disconnect(); setTimeout(run, 300); } }), {threshold: .5});
      io.observe(root);
    });
  };

  // Weg zu dir: Punktkarte – LKW aus Europa ist da, Containerschiff noch in Asien
  const initRaceMap = () => {
    $$('[data-np-racemap]').forEach(root => {
      if (root.dataset.npRmInit) return; root.dataset.npRmInit = '1';
      const us = +root.dataset.us || 5, them = +root.dataset.them || 42, end = +root.dataset.end || 5;
      const road = root.querySelector('[data-np-rm-road]'), sea = root.querySelector('[data-np-rm-sea]');
      const truck = root.querySelector('[data-np-rm-truck]'), ship = root.querySelector('[data-np-rm-ship]'), day = root.querySelector('[data-np-day]');
      if (!road || !sea) return;
      const Lr = road.getTotalLength(), Ls = sea.getTotalLength();
      [[road, Lr], [sea, Ls]].forEach(([p, L]) => { p.style.strokeDasharray = L + ' ' + L; });
      const sc = () => innerWidth < 900 ? 1.7 : 1;
      const place = (g, path, L, k) => { const pt = path.getPointAtLength(L * k); g.setAttribute('transform', `translate(${pt.x.toFixed(1)} ${pt.y.toFixed(1)}) scale(${sc()})`); };
      const set = d => { const ku = Math.min(1, d / us), ks = Math.min(1, d / them);
        road.style.strokeDashoffset = Lr * (1 - ku); sea.style.strokeDashoffset = Ls * (1 - ks);
        place(truck, road, Lr, ku); place(ship, sea, Ls, ks);
        if (day) day.textContent = Math.floor(d + 1e-6); root.classList.toggle('is-arrived', d >= us - 1e-6); };
      let raf = 0;
      const run = () => { cancelAnimationFrame(raf); set(0); const t0 = performance.now(), dur = 4800;
        const step = t => { const k = Math.min(1, (t - t0) / dur); set(end * (k < 1 ? 1 - Math.pow(1 - k, 1.5) : 1)); if (k < 1) raf = requestAnimationFrame(step); };
        raf = requestAnimationFrame(step); };
      const again = root.querySelector('[data-np-rm-again]'); if (again) again.addEventListener('click', run);
      addEventListener('resize', () => { if (root.classList.contains('is-arrived')) set(end); });
      if (reduce || !('IntersectionObserver' in window)) { set(end); return; }
      set(0);
      const io = new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { io.disconnect(); setTimeout(run, 400); } }), {threshold: .45});
      io.observe(root);
    });
  };

  // Nach der Bestellung: kompakter Live-Status, spielt sich selbst ab, Punkte antippbar
  const initJourney = () => {
    $$('[data-np-jr2]').forEach(root => {
      if (root.dataset.npJrInit) return; root.dataset.npJrInit = '1';
      const nodes = $$('[data-np-j2-node]', root), lis = nodes.map(n => n.closest('li')), titles = $$('[data-np-j2-title]', root), panels = $$('[data-np-j2-panel]', root);
      const kEl = root.querySelector('[data-np-j2-k]'), N = nodes.length, DUR = 2600; let k = 0, timer = 0;
      if (!N) return;
      const set = i => { k = Math.max(0, Math.min(N - 1, i)); root.style.setProperty('--k', k);
        lis.forEach((li, j) => { li.classList.toggle('is-done', j < k || (j === N - 1 && k === N - 1 && root.classList.contains('is-end'))); li.classList.toggle('is-cur', j === k); });
        titles.forEach((t, j) => t.classList.toggle('is-cur', j === k)); panels.forEach((p, j) => p.classList.toggle('is-cur', j === k));
        if (kEl) kEl.textContent = k + 1; };
      const finish = () => { root.classList.remove('is-play'); root.classList.add('is-end'); set(N - 1); };
      const play = () => { clearTimeout(timer); root.classList.remove('is-play'); void root.offsetWidth; root.classList.add('is-play'); root.style.setProperty('--dur', DUR + 'ms');
        timer = setTimeout(() => { if (k < N - 1) { set(k + 1); play(); } else finish(); }, DUR); };
      nodes.forEach((n, i) => n.addEventListener('click', () => { clearTimeout(timer); root.classList.remove('is-play'); root.classList.toggle('is-end', i === N - 1); set(i); }));
      if (reduce || !('IntersectionObserver' in window)) { root.classList.add('is-end'); set(N - 1); return; }
      set(0);
      const io = new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { io.disconnect(); setTimeout(play, 300); } }), {threshold: .55});
      io.observe(root);
    });
  };

  const init = () => { initImages(); initRace(); initRaceMap(); initJourney(); initScale(); initBehind(); initXray(); initFx(); initSketches(); initScrolly(); initRevealStage(); initMaps(); initReveal(); initToc(); initVideos(); initCounters(); document.dispatchEvent(new CustomEvent('nordestic:pages-ready')); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* Baum-Zähler: Live-Zahl von GoodAPI (fällt bei Fehlern still auf die Zahl aus dem Theme zurück) */
(() => {
  const fmt = n => Math.round(n).toLocaleString('fr-FR');
  const run = root => {
    const set = (sel, v) => root.querySelectorAll(sel).forEach(e => { e.textContent = v; });
    const apply = (total, month) => {
      const goal0 = parseInt(root.dataset.goal, 10) || 50000;
      let goal = goal0; while (goal <= total) goal += 10000;
      const co2 = (parseFloat(root.dataset.co2) || 0) * total / 1000;
      set('[data-np-trees-goal]', fmt(goal));
      set('[data-np-trees-left]', `encore ${fmt(goal - total)}`);
      set('[data-np-trees-co2]', fmt(co2));
      if (month != null) set('[data-np-trees-month]', fmt(month));
      const bar = root.querySelector('[data-np-trees-bar]'); if (bar) bar.style.width = Math.min(100, total / goal * 100) + '%';
      const num = root.querySelector('[data-np-trees-total]');
      if (num) { num.dataset.npCount = String(total); num.textContent = fmt(total); }
    };
    const start = parseInt((root.querySelector('[data-np-trees-total]')?.textContent || '0').replace(/\D/g, ''), 10) || 0;
    apply(start, null);
    const url = root.dataset.api;
    if (!url) return;
    fetch(url, {credentials: 'omit'}).then(r => r.ok ? r.json() : null).then(j => {
      if (!j) return;
      const total = Number(j.total_trees_planted ?? j.total_planted_trees);
      if (isFinite(total) && total > 0) apply(total, Number(j.total_trees_current_month ?? j.total_planted_trees_month));
    }).catch(() => {});
  };
  const init = () => document.querySelectorAll('[data-np-trees]').forEach(run);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
